import { RightOutlined, SearchOutlined , EyeOutlined, PrinterOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from 'react'
import { Button, Col, DatePicker, Form, Input, PageHeader, Row, Select, Space, Spin, Table } from 'antd'
import moment from 'moment';

import JcpMonthlyPaidListView from '../../components/enrollment/jcp/JcpMonthlyPaidListView'
import ProgrammeService from '../../api/programme.service'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'
import PaymentPaidList from '../../components/payment/PaymentPaidList'

import { SUCCESS_STATUS , DATE_FORMAT_DMY_SLASH, TAP_PROGRAM_ID } from '../../utility/Constants'
import memberService from "../../api/member.service";
import JcpMonthlyReminderListView from "../../components/enrollment/jcp/JcpMonthlyReminderListView";
import TapMembershipListView from "../../components/tapcomponent/TapMembershipListView";
import commonUtility from "../../utility/Utils";
import TapBookingListView from "../../components/tapcomponent/TapBookingListView";
import TapDailyBookingCardView from "../../components/tapcomponent/TapDailyBookingCardView";
import { DATE_FORMAT_DMY_HYPHEN } from "../../utility/Constants";
import { TAP_ADULT_COAHING_PRINT_URL, TAP_INVOICE_BOOKING_LIST_PDF_URL, TAP_SPECIAL_DAILY_PRINT_URL } from "../../utility/URL";
const { Option } = Select;





const currdate = new Date();
//const currMonth = currdate.toLocaleString('default', { month: 'short' });
const currMonth = currdate.getMonth() + 1;
const currYear = currdate.getFullYear();



const defaultFormValues = {
   

    from_date: commonUtility.todayDate("-"),
    to_date :  commonUtility.todayDate("-"),
    tap_group : 'TAPM',
    is_active : 'ACTIVE'

};



const columns = [
    {
        title: 'Name',
        dataIndex: 'member_fname',
        key: 'member_fname',
    },
    {
        title: 'Mobile No',
        dataIndex: 'primary_mobile',
        key: 'primary_mobile',
    },
    {
        title: 'Father',
        dataIndex: 'father_name',
        key: 'father_name',
    },
];


const TapBookingList = () => {

    const [form] = Form.useForm();
    const [tapBookingList, setTapBookingList] = useState([]);
    const [isDataUpdated, setIsDataUpdated] = useState(false);
    const [reminderLoaderEnable, setReminderLoaderEnable] = useState(false);
    const [selectedFromDate, setSelectedFromDate] = useState(commonUtility.todayDate("-"));
    const [selectedEndDate, setSelectedEndDate] = useState("");
    const [isDateOpen, setIsDateOpen] = useState(false);
    const [memberList, setMemberList] = useState([]);
    const [isMemberEnable, setIsMemberEnable] = useState(true);
    const [listType, setListType] = useState("LIST");

    const [tapBookingPDFUrl, setTapBookingPDFUrl] = useState("");


    // const onActiveBookingChange = (value) => {
    //     console.log("event", value)

    //     if(value == "ACTIVE") {
    //         setIsDateOpen(false)
    //         form.setFieldsValue({
    //             from_date_picker:null,
    //             to_date_picker:null,
    //             from_date: '',
    //             to_date: ''
    //         });
    //     }
    //     else {
    //         setIsDateOpen(true)
    //     }
        
    // }

    const onFromDateChange = (date, dateString) => {
        // console.log(date, dateString);
        setSelectedFromDate(dateString)
        form.setFieldsValue({
            from_date: dateString
        });
    };

    const onFromDateLoad = () => {
        // console.log(date, dateString);
       // setSelectedFromDate(dateString)
        console.log('fromdate',form.getFieldValue('from_date_picker'));
    };

    const onEndDateChange = (date, dateString) => {
        // console.log(date, dateString);
        setSelectedEndDate(dateString)
        form.setFieldsValue({
            to_date: dateString
        });

    };


    const onViewTypeChange = (v,e) => {
        setTapBookingList([]);
       if(v == "LIST") {
        setListType("LIST");
        setIsMemberEnable(true)
       }
       else{
        setListType("DAILY");
        setIsMemberEnable(false)
       }
    }


    const onFormSearched = async (values) => {
        setTapBookingList([])
        

        const dataForList = { formdata: {
            from_date : values.from_date,
            to_date : values.to_date,
            member_id : values?.member_id != undefined ? values?.member_id : 0,
            tap_group: values.tap_group != undefined ? values.tap_group : ""
        }};

        const dataForDailyBooking = { formdata: {
            from_date : values.from_date,
            tap_group: values.tap_group != undefined ? values.tap_group : ""
        }};

        if(listType == "LIST") {
            let mid = values?.member_id || 0;
            let url = TAP_INVOICE_BOOKING_LIST_PDF_URL + "/" + values.from_date + "/" + values.to_date + "/" + values.tap_group + "/" + mid;

            // console.log('url',TAP_INVOICE_BOOKING_LIST_PDF_URL);
            // console.log('values.from_date',values.from_date);
            // console.log('values.to_date',values.to_date);
            // console.log('values.tap_group',values.tap_group);
            // console.log('values.member_id',values.member_id);
            // console.log('TAP_INVOICE_BOOKING_LIST_PDF_URL',TAP_INVOICE_BOOKING_LIST_PDF_URL);
            // console.log('url',url);

            setTapBookingPDFUrl(url);
            ProgrammeService.tapBookingList(dataForList).then((res) => {
                if(commonUtility.sanitizeObject(res)) {
                    setTapBookingList(res.data.response_data)
                }
                setIsDataUpdated(!isDataUpdated)
            });
        }
        else{

            console.log('values',values);
            if(dataForList.tap_group !="" && values.tap_group == "TAPSC"){
                console.log('console.log()',values);
                window.open(`${TAP_SPECIAL_DAILY_PRINT_URL}${values.from_date}/${values.to_date}`, '_blank', 'noreferrer');
            }else{
                console.log('console.log()x',values);
                window.open(`${TAP_ADULT_COAHING_PRINT_URL}${values.from_date}/${values.to_date}/${TAP_PROGRAM_ID}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}`, '_blank', 'noreferrer');
            }

            
            /*
            ProgrammeService.tapDailyBookingList(dataForDailyBooking).then((res) => {
                if(commonUtility.sanitizeObject(res)) {
                    //setTapBookingList(res.data.response_data)

                   let resp_data = res.data.response_data;
                   let data = [];

                   let required_block = 6;


                  
                   for(let i = 0; i < resp_data.length; i++){
                        let detailData = [];
                        let masterData =  {
                            time_slot: resp_data[i].masterData.time_slot,
                            time_slot_id: resp_data[i].masterData.time_slot_id
                        };

                        

                        let detail_data = resp_data[i].detailsData;
                        //let detail_data = 5;
                        let detail_data_length = detail_data.length;
                        let remaining = required_block - detail_data_length;

                        for(let k=0; k< detail_data_length; k++){
                            let dtl =  {
                                booking_date: detail_data[k].booking_date,
                                time_slot_id: detail_data[k].time_slot_id,
                                is_with_coach: detail_data[k].is_with_coach,
                                member_fname: detail_data[k].member_fname,
                                member_lname: detail_data[k].member_lname,
                                book_start_month: detail_data[k].book_start_month,
                                book_end_month: detail_data[k].book_end_month,
                                receipt_id: detail_data[k].receipt_id,
                                co_partner_ids: detail_data[k].co_partner_ids,
                                co_members: detail_data[k].co_members,
                                receipt_no: detail_data[k].receipt_no,
                                receipt_date: detail_data[k].receipt_date,
                                net_payble_amount: detail_data[k].net_payble_amount,
                            };
                            detailData.push(dtl);
                        }
                        pushData(remaining,detailData);
                        data.push({
                            "masterData" : masterData,
                            "detailsData" : detailData,
                        });
                        
                   }


                   //console.log('overview',data);
                   setTapBookingList(data)

                }
                
                setIsDataUpdated(!isDataUpdated)
            });
            */
        }
        



    };


    const pushData = (diff,obj) => {
        for(let k=0; k<diff; k++){
            let dtl =  {
                booking_date: "",
                time_slot_id: "",
                is_with_coach: "",
                member_fname: "",
                member_lname: "",
                book_start_month: "",
                book_end_month: "",
                receipt_id: "",
                co_partner_ids: "",
                co_members: "",
            };
            obj.push(dtl);
        }
        return obj;
    }


    useEffect(() => {
        
        memberService.memberListOnceTap().then((res) => {
            if(res.data.response_status === SUCCESS_STATUS) {
               setMemberList(res.data.response_data);
            }
        });

    }, []);



    return (




        <div>


            <div className="inside-main-content">
                <AdminBreadCrumb />

                <div className="box-style">
                    <PageHeader
                        ghost={false}
                        onBack={() => window.history.back()}
                        title="Tap Booking / Special Coaching List"
                        subTitle=""

                    ></PageHeader>

                    <Row className="" style={{ background: "#f4f4f4" }}>
                        <Col className="" xs={24} xl={24}>

                            <Form
                                form={form}
                                layout="vertical"
                                onFinish={onFormSearched}
                                autoComplete="off"
                                initialValues={defaultFormValues}
                                
                            >

                                <Row gutter={20} style={{ margin: "0.5rem" }}>
                                    {/* <Col xs={4} xl={4} >
                                        <Form.Item name="tap_group" label="Morning/Special" >
                                            <Select className="text-left" allowClear={true} >
                                                <Option value="TAPM"> TAP Morning</Option>
                                                <Option value="TAPSP"> Special Coaching</Option>
                                            </Select>
                                        </Form.Item>
                                    </Col> */}

                                        <Col xs={24} xl={3} >
                                            <Form.Item name="from_date_picker" label="From Date">
                                                <DatePicker
                                                    format={DATE_FORMAT_DMY_HYPHEN}
                                                    onChange={onFromDateChange}
                                                    style={{ width: "100%" }}
                                                    inputReadOnly={true}
                                                    defaultValue={moment(commonUtility.todayDate(), DATE_FORMAT_DMY_HYPHEN)}
                                                    placeholder=""
                                                />
                                            </Form.Item>
                                            <Form.Item name="from_date" hidden={true}>
                                                <Input type="text" />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={3} >

                                            <Form.Item name="to_date_picker" label="To Date" >
                                                <DatePicker
                                                    format={DATE_FORMAT_DMY_HYPHEN}
                                                    onChange={onEndDateChange}
                                                    style={{ width: "100%" }}
                                                    inputReadOnly={true}
                                                    defaultValue={moment(commonUtility.todayDate(), DATE_FORMAT_DMY_HYPHEN)}
                                                   
                                                    placeholder=""
                                                />
                                            </Form.Item>
                                            <Form.Item name="to_date" hidden={true}>
                                                <Input type="text" />
                                            </Form.Item>

                                        </Col>

                                        <Col xs={4} xl={5} >
                                            <Form.Item name="view_type" label="Invoice/Booking Chart">
                                                <Select className="text-left" allowClear={true} onChange={(value, event) => onViewTypeChange(value, event)} defaultValue="LIST"
                                                >
                                                    <Option value="LIST" >Invoice</Option>
                                                    <Option value="DAILY" >Booking Chart</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={4} xl={4} >
                                            <Form.Item name="tap_group" label="Type">
                                                <Select className="text-left">
                                                    <Option value="TAPM" valueText="Adult Coaching">Adult Coaching</Option>
                                                    <Option value="TAPSC" valueText="Special Coaching">Special Coaching</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={4} xl={6} >
                                            <Form.Item name="member_id" label="Member's" >
                                                    <Select
                                                        disabled={!isMemberEnable}
                                                        allowClear
                                                        showSearch
                                                        placeholder="Search to Select"
                                                        optionFilterProp="children"
                                                        filterOption={(input, option) =>
                                                            //option.children.includes(input)
                                                            option.children.toLowerCase().includes(input.toLowerCase())
                                                        }
                                                        filterSort={(optionA, optionB) =>
                                                            optionA.children
                                                                .toLowerCase()
                                                                .localeCompare(optionB.children.toLowerCase())
                                                        }
                                                        
                                                    >
                                                        {memberList.length > 0
                                                            ? memberList.map((member_list) => (
                                                                <Option
                                                                    key={member_list.member_id}
                                                                    value={member_list.member_id}
                                                                >
                                                                    {`${member_list.member_fname} ${member_list.member_lname}`}
                                                                </Option>
                                                            ))
                                                            : ""}
                                                    </Select>
                                            </Form.Item>
                                        </Col>
                                        




                                    <Col xs={4} xl={3} >
                                        <Form.Item label=" ">
                                            {
                                                reminderLoaderEnable ? <Spin /> : <>
                                                    <Button
                                                        htmlType="submit"
                                                        shape="round"
                                                        className="custom-button-green"
                                                    >
                                                        Show <EyeOutlined />
                                                    </Button>
                                                </>
                                            }

                                        </Form.Item>
                                    </Col>



                                </Row>
                            </Form>




                        </Col>
                    </Row>


                    <div className='tableView' style={{background:'#f9f9f9'}}>
                        <div className="form-content">
                            {
                                listType == "LIST" ? <>
                                    
                                    {
                                        commonUtility.sanitizeObject(tapBookingPDFUrl) != "" ? <>
                                            <Button key="membershipButtonPDF" className="custom-button-white" size="medium" style={{margin:10}} onClick={() => commonUtility.openInNewTab(tapBookingPDFUrl)}>
                                            <PrinterOutlined /> Get PDF
                                            </Button>
                                        </> : <></>
                                    }
                                    

                                    <TapBookingListView tapBookingList={tapBookingList} />
                                </> : <>
                                    <TapDailyBookingCardView tapBookingList={tapBookingList} fromDate={selectedFromDate} key={commonUtility.randomID()} />
                                </>
                            }
                        </div>
                    </div>

                </div>
            </div>

        </div>







    )
}

export default TapBookingList